import React from 'react';
import { call, put } from 'redux-saga/effects';
import { takeLatest } from '../../../utils/reduxSaga';

import { URLS } from '../../../consts/endpoints';
import { actions as reduxActions } from '../reducers';
import { actions as sagaActions, GET_ACCOUNTS } from './types';
import { actions as loaderReducActions } from '../../../partials/loader/reducers';
import { getData } from '../../../utils/http';
import Optional from '../../../utils/optional';
import orderBy from 'lodash.orderby';

export function fetchAccounts(clientId) {
  return {
    type: sagaActions[GET_ACCOUNTS],
    clientId
  };
}

export function* getAccounts({ clientId }) {
  yield put(loaderReducActions.startSpinLoader());

  let accounts = [],
    selectOptions = [],
    selectedAccount = {};

  try {
    const data = yield call(
      getData,
      `${URLS.QUOTE_CLIENTS}/${clientId}/accounts`
    );

    accounts = data;
    selectOptions = yield call(createSelectOptions, data);

    selectedAccount = Optional(selectOptions[0]).or({});
  } catch {
  } finally {
    yield put(
      reduxActions.setAccounts(accounts, selectOptions, selectedAccount)
    );
    yield put(loaderReducActions.stopSpinLoader());
  }
}

function* watchGetAccounts() {
  yield takeLatest(sagaActions[GET_ACCOUNTS], getAccounts);
}

export default watchGetAccounts();

function createSelectOptions(data = []) {
  const options = data.map(el => {
    const { id, name, accountNo, type } = el;
    return {
      value: id,
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginLeft: '5px' }}>{`${name} - ${accountNo}`}</div>
          {type === 'CUSTOMER' ? (
            <i className="fas fa-handshake-alt"></i>
          ) : (
            <i className="fal fa-money-bill-alt"></i>
          )}
        </div>
      ),
      shortLabel: `${name} - ${accountNo}`,
      filterLabel: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {type === 'CUSTOMER' ? (
            <i className="fas fa-handshake-alt"></i>
          ) : (
            <i className="fal fa-money-bill-alt"></i>
          )}
          <div style={{ margin: '5px' }}>{`${name} - ${accountNo}`}</div>
        </div>
      ),
      ...el
    };
  });

  if (options.length > 1) {
    const customerAccounts = options.filter(el => el.type === 'CUSTOMER');
    const invoiceAccounts = options.filter(el => el.type === 'INVOICE');

    return [
      ...orderBy(customerAccounts, 'shortLabel'),
      ...orderBy(invoiceAccounts, 'shortLabel')
    ];
  }

  return options;
}
